import { ReactElement } from "react";

import { Text } from "./catalyst/Text";

export const GraphDetailText = ({ text }: { text: string }): ReactElement => (
  <Text className="block max-w-52 truncate" size="xs">
    {text}
  </Text>
);
